import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    setCampaigns(state, campaigns) {
        state.campaigns = campaigns;
    },

    setSelectedCampaign(state, campaign) {
        state.selectedCampaign = campaign;
    },

    addPlaceholder(state, placeholder) {
        state.selectedCampaign.placeholders.push(placeholder);
    },

    clearSelectedCampaign(state) {
        state.selectedCampaign = {};
    },

    addCampaign(state, campaign) {
        state.campaigns.push(campaign);
    },

    updateCampaign({ campaigns, selectedCampaign }, updatedCampaign) {
        if (!updatedCampaign.id) {
            return;
        }

        // Update campaigns array
        campaigns.forEach(campaign => {
            if (campaign.id == updatedCampaign.id) {
                Object.assign(campaign, updatedCampaign);
            }
        });

        // Update selected campaign
        if (selectedCampaign.id == updatedCampaign.id) {
            Object.assign(selectedCampaign, updatedCampaign);
        }
    },

    deleteCampaign({ campaigns }, campaignId) {
        // Remove from campaigns array
        const campaignIndex = campaigns.findIndex(c => c.id == campaignId);

        if (campaignIndex !== -1) {
            campaigns.splice(campaignIndex, 1);
        }
    },
};
